/** Throws if value is falsy (null, undefined, "", 0). Mirrors Kotlin's require(condition). */
export function require(value: unknown): asserts value {
  if (!value) throw new Error('Required value was null or empty')
}
